export default class ExtranetIncidentsEdit {

    constructor() {
        this.responsibleForId = null;
        this.currentResponsibleId = null;
        this.bindEvents();
        this.loadResponsible();
        //window.application.setOnDataChangeListener(this);
    }


    bindEvents() {
        this.dropify = $('#file').dropify({
            messages: {
                'default': I18n.t('plugins.dropify.messages.default'),
                'replace': I18n.t('plugins.dropify.messages.replace'),
                'remove':  I18n.t('plugins.dropify.messages.remove'),
                'error':   I18n.t('plugins.dropify.messages.error')
            },
            error: {
                'fileSize': I18n.t('plugins.dropify.messages.fileSize'),
                'minWidth': I18n.t('plugins.dropify.messages.minWidth'),
                'maxWidth': I18n.t('plugins.dropify.messages.maxWidth'),
                'minHeight': I18n.t('plugins.dropify.messages.minHeight'),
                'maxHeight': I18n.t('plugins.dropify.messages.maxHeight'),
                'imageFormat': I18n.t('plugins.dropify.messages.imageFormat'),
                'fileExtension': I18n.t('plugins.dropify.messages.fileExtension')
            }});

        // Initialize Dropify for comment file upload
        this.commentDropify = $('#comment_file').dropify({
            messages: {
                'default': I18n.t('plugins.dropify.messages.default'),
                'replace': I18n.t('plugins.dropify.messages.replace'),
                'remove':  I18n.t('plugins.dropify.messages.remove'),
                'error':   I18n.t('plugins.dropify.messages.error')
            },
            error: {
                'fileSize': I18n.t('plugins.dropify.messages.fileSize'),
                'minWidth': I18n.t('plugins.dropify.messages.minWidth'),
                'maxWidth': I18n.t('plugins.dropify.messages.maxWidth'),
                'minHeight': I18n.t('plugins.dropify.messages.minHeight'),
                'maxHeight': I18n.t('plugins.dropify.messages.maxHeight'),
                'imageFormat': I18n.t('plugins.dropify.messages.imageFormat'),
                'fileExtension': I18n.t('plugins.dropify.messages.fileExtension')
            }
        });

        $('#send_comment_incident_form').submit((e) => {
            if($('#text_comment').val().trim() === ""){
                e.preventDefault()
                return false;
            }

            application.openLoader();
        })

        this.bindResponsibleEvents();
    }

    /**
     * Load the current responsible for this incident via AJAX
     */
    loadResponsible() {
        const $field = $('#responsible-field');
        if ($field.length === 0) return; // Not a Nexsupport user

        const responsibleUrl = $field.data('responsible-url');
        if (!responsibleUrl) return;

        $.ajax({
            url: responsibleUrl,
            method: 'GET',
            dataType: 'json'
        }).then(data => {
            $('#responsible-loading').hide();
            const name = data.name || '--';
            this.currentResponsibleId = data.id || null;
            this.responsibleForId = data.responsible_for_id || null;

            $('#responsible-name-input').val(name);
            $('#edit-responsible-btn').show();

            // Pre-select the current responsible in the dropdown
            if (this.currentResponsibleId) {
                $('#responsible-select').val(this.currentResponsibleId);
            }
        }).catch(() => {
            $('#responsible-loading').hide();
            $('#responsible-name-input').val('--');
            $('#edit-responsible-btn').show();
        });
    }

    /**
     * Bind events for the responsible edit form (Nexsupport only)
     */
    bindResponsibleEvents() {
        const self = this;

        // Initialize select2 for responsible select
        $('#responsible-select').select2({
            placeholder: '-- Sélectionner un porteur --',
            allowClear: true,
            width: '100%'
        });

        $('#edit-responsible-btn').on('click', () => {
            $('#responsible-display').hide();
            $('#responsible-edit-form').show();
        });

        $('#cancel-responsible-btn').on('click', () => {
            $('#responsible-edit-form').hide();
            $('#responsible-display').show();
        });

        $('#save-responsible-btn').on('click', () => {
            const newResponsibleId = $('#responsible-select').val();
            if (!newResponsibleId) return;

            const $field = $('#responsible-field');
            const updateUrl = $field.data('update-responsible-url');

            const csrfToken = $('meta[name="csrf-token"]').attr('content');

            const payload = {
                responsible_id: newResponsibleId,
                responsible_for_id: self.responsibleForId || ''
            };

            $('#save-responsible-btn').prop('disabled', true).html(
                '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
            );

            $.ajax({
                url: updateUrl,
                method: 'PATCH',
                dataType: 'json',
                data: payload,
                headers: { 'X-CSRF-Token': csrfToken }
            }).then(response => {
                if (response.success) {
                    // Update the displayed name
                    const selectedText = $('#responsible-select option:selected').text();
                    $('#responsible-name-input').val(selectedText);
                    self.currentResponsibleId = newResponsibleId;

                    // Update responsibleForId if returned
                    if (response.data && (response.data.responsibleForId || response.data.id)) {
                        self.responsibleForId = response.data.responsibleForId || response.data.id;
                    }

                    $('#responsible-edit-form').hide();
                    $('#responsible-display').show();
                } else {
                    alert(response.error || 'Erreur lors de la mise à jour');
                }
            }).catch(() => {
                alert('Erreur lors de la mise à jour du porteur');
            }).always(() => {
                $('#save-responsible-btn').prop('disabled', false).html('<i class="fas fa-check"></i>');
            });
        });
    }

    onDataChanged(data) {
    }

    onDestroy() {
    }
}